:host {
  display: block;
}

.dealer-listing-enhancement__icon {
  color: var(--clrs-bg-global-icon-default);
}
